"use strict";

var $ = jQuery;

function initFeaturedHeadlines() {
    loadChildContent().then(function () {
      $('.news_feature_wrapper').css('visibility', 'visible');
    });

    function loadChildContent() {
      return $.Deferred(function (defer) {
        setTimeout(function () {
          defer.resolve();
        }, 100);
      }).promise();
    }

      var $dynamicHeading = $('#dynamicHeading');
      var $placeholder = $('<div id="dynamicHeading-placeholder"></div>');
      var $originalClone = $dynamicHeading.clone(true, true);
      var isAttached = true;

      $dynamicHeading.after($placeholder);

      function restructureItems(originalHTML) {
        var $items = $('<div>' + originalHTML + '</div>').find('.featured_news_listing_item');
        var $bodyWrapper = $('<div class="featured_news_listing_desktop_bodies"></div>');
        var $figureWrapper = $('<div class="featured_news_listing_desktop_figures"></div>');
    
        $items.each(function(index) {
          var $item = $(this);
          var $body = $item.find('.featured_news_listing_item_body');
          var $figure = $item.find('.featured_news_listing_item_figure');
    
          $body.attr('data-index', index);
          $figure.attr('data-index', index).addClass('desktop-figure').hide();

          if (index === 0) {
            $body.addClass('desktop-selected');
          }
    
          $bodyWrapper.append($body);
          $figureWrapper.append($figure);

          var $wrapper = $figure.find('.fadein-image');
          $wrapper.addClass('is-loaded');
    
          $body.on('mouseenter', function () {
            $figureWrapper.find('.desktop-figure').hide();
            $figure.show();

            //new
            $bodyWrapper.find('.featured_news_listing_item_body').removeClass('desktop-selected');
            $body.addClass('desktop-selected');
          });
        });

        $figureWrapper.find('.desktop-figure').first().show();

        return $('<div class="featured_news_listing_desktop"></div>')
          .append($bodyWrapper)
          .append($figureWrapper);

      }

      function handleResize() {
        var windowWidth = window.innerWidth;

        if (windowWidth >= 740 && isAttached) {
          var originalHTML = $dynamicHeading.html();
          $dynamicHeading.detach();

          var $restructured = restructureItems(originalHTML);
          $placeholder.after($restructured);

          $('.news_item_title_link').attr('tabindex', '0');

          isAttached = false;

        } else if (windowWidth <= 739 && !isAttached) {
          $('.featured_news_listing_desktop').remove();
          $placeholder.after($dynamicHeading);
          $dynamicHeading = $('#dynamicHeading');
          $('.news_item_title_link').attr('tabindex', '-1');
          isAttached = true;
        }
      }

      handleResize();

      $(window).on('resize', function() {
        handleResize();
      });
}

$(initFeaturedHeadlines);